<script lang="ts">
import "@cisco-u/icons/icons/cu-icon-close-x.js";

import { defineComponent } from "vue";

export default defineComponent({
  emits: ["close-genai-model"],
  props: {
    showBgImage: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div
    class="mx-auto my-0 overflow-hidden rounded-t-lg border border-b-0 border-black-light bg-black-dark dark:bg-black"
  >
    <div class="modal-header">
      <div
        class="flex items-center justify-between text-black py-1 dark:text-white"
      >
        <div class="relative m-auto w-full items-center text-center">
          <div
            v-if="showBgImage"
            class="m-auto my-12 flex items-center justify-center gap-4 w-full"
          >
            <img
              src="@/layout/GenAIBeta/assets/cisco_ai_assistant_symbol.png"
              alt="AI prompt icon"
              class="w-[200px] h-[200px]"
            />
          </div>
          <div
            v-else
            class="m-auto my-2 flex items-center justify-center gap-4 w-full"
          >
            <img
              src="@/layout/GenAIBeta/assets/cisco_ai_assistant.png"
              alt="AI prompt icon"
              class="w-[1.75rem]"
            />
            <span
              class="text-white py-[0.313rem] text-center text-18 font-normal"
              >AI Assistant</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
